import { useConfig } from '@browsing/config';
import { useLazyVariant } from '@pegasus/abtesting';
export var useProductPreviewInCartFeature = function () {
    var config = useConfig();
    var isProductPreviewInCartFeatureEnabled = config.isEnabled('product_preview_in_cart');
    var _a = useLazyVariant('convert-product-preview-in-cart', 'variant_cart_product_preview'), isVariantProductPreviewInCart = _a[0], sendFeedback = _a[1];
    return {
        isProductPreviewInCartEnabled: isProductPreviewInCartFeatureEnabled && !!isVariantProductPreviewInCart,
        sendFeedbackProductPreviewInCart: isProductPreviewInCartFeatureEnabled
            ? sendFeedback
            : function () { },
    };
};
